import { GanttIndicatorsDialog } from "@/ds";

import type { IndicadoresDialogViewModel } from "./types-indicadores-dialog";

export function IndicadoresDialogView({
  options,
  value,
  escolher,
  cancelar,
}: IndicadoresDialogViewModel) {
  return (
    <GanttIndicatorsDialog
      visible
      onHide={cancelar}
      options={options}
      value={value}
      onChange={escolher}
      testId="indicators"
    />
  );
}
